import { createApi } from '@reduxjs/toolkit/query/react';
import { client } from '../../../api/NestClient';
import { nestBaseQuery } from '../../../utils/nestBaseQuery';
import type { components, paths } from '../../../api/types/api';
import { getCompanyCodeTranslationApi } from '../../../redux/apis/getCompanyCodeTranslation.api';
import { unitApi } from '../../Item/api/unit.api';

export interface UpdateUnitStatusRequest {
  unitId: number;
  isactive: components['schemas']['UpdateItemUnitStatusDto']['isactive'];
}
type AddUnitRequest = components['schemas']['CreateItemUnitDto'];
type UnitMutationResponse = components['schemas']['ItemUnitActionResponseDto'];
type UnitListResponse = paths['/api/v1/items/units/list']['get']['responses'][200]['content']['application/json'];

const UNITS_CODE_TRANSLATION_TAG = { type: 'CodeTranslation' as const, id: 'UNITS' };

const invalidateCompanyCodeTranslationUnits = async (
  _arg: unknown,
  { dispatch, queryFulfilled }: { dispatch: (action: unknown) => unknown; queryFulfilled: Promise<unknown> }
) => {
  try {
    await queryFulfilled;
    dispatch(getCompanyCodeTranslationApi.util.invalidateTags([UNITS_CODE_TRANSLATION_TAG]));
    dispatch(unitApi.util.invalidateTags(['unitSettings']));
  } catch {
  }
};

export const unitDataApi = createApi({
  reducerPath: 'unitDataApi',
  baseQuery: nestBaseQuery,
  tagTypes: ['UnitList'],
  endpoints: (builder) => ({
    getUnitList: builder.query<UnitListResponse, void>({
      query: () => client.GET('/api/v1/items/units/list'),
      providesTags: [{ type: 'UnitList', id: 'LIST' }],
    }),
    addUnit: builder.mutation<UnitMutationResponse, AddUnitRequest>({
      query: (body) =>
        client.POST('/api/v1/items/units', {
          body,
        }),
      invalidatesTags: [{ type: 'UnitList', id: 'LIST' }],
      onQueryStarted: invalidateCompanyCodeTranslationUnits,
    }),
    deleteUnit: builder.mutation<UnitMutationResponse, number>({
      query: (unitId) =>
        client.DELETE('/api/v1/items/units/{unitId}', {
          params: { path: { unitId } },
        }),
      invalidatesTags: [{ type: 'UnitList', id: 'LIST' }],
      onQueryStarted: invalidateCompanyCodeTranslationUnits,
    }),
    updateUnitStatus: builder.mutation<UnitMutationResponse, UpdateUnitStatusRequest>({
      query: ({ unitId, isactive }) =>
        client.PATCH('/api/v1/items/units/{unitId}/status', {
          params: { path: { unitId } },
          body: { isactive },
        }),
      invalidatesTags: [{ type: 'UnitList', id: 'LIST' }],
      onQueryStarted: invalidateCompanyCodeTranslationUnits,
    }),
  }),
});
export const {
  useGetUnitListQuery,
  useAddUnitMutation,
  useDeleteUnitMutation,
  useUpdateUnitStatusMutation,
} = unitDataApi;